let operationSequence = 0

export const EVENT_OPERATION_COMPLETION_TIMEOUT_MS = 60000

export const createEventOperationId = operation => {
  operationSequence += 1
  return `${operation}-${Date.now()}-${operationSequence}`
}
